export default __webpack_public_path__ + "static/media/ls-it-losses.847eb9ea.svg";